import { hideAddCommentModal, showSuccessAlert } from "@actions/modals";
import React from "react";
import { connect } from "react-redux";
import { Button, Form, Header, Modal, TextArea } from "semantic-ui-react";

class AddCommentModal extends React.Component {
  state = {
    value: "",
  };

  handleClose = () =>
    this.props
      .hideAddCommentModal(false)
      .then(() => this.setState({ value: "" }));

  handleSave = () =>
    this.props.modal
      .onSave(this.state.value)
      .then(() => this.setState({ value: "" }));

  render() {
    const { value } = this.state;
    const { header, subHeader } = this.props.modal;
    return (
      <Modal
        open={this.props.modal.open}
        onClose={this.handleClose}
        size="small"
        closeIcon
      >
        <Modal.Header>Add Comment</Modal.Header>
        <Modal.Content className="h-100">
          <Header size="small">
            {header}
            <Header.Subheader>{subHeader}</Header.Subheader>
          </Header>
          <Form>
            <TextArea onChange={(event, { value }) => this.setState({ value })}>
              {value}
            </TextArea>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={this.handleClose}>
            Cancel
          </Button>
          <Button
            positive
            disabled={value.length < 1}
            onClick={this.handleSave}
          >
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.addCommentModal,
  };
};

export default connect(mapStateToProps, {
  hideAddCommentModal,
  showSuccessAlert,
})(AddCommentModal);
